module.exports = __webpack_public_path__ + "img/reporting.587d2f8a.svg";